import React from 'react';
import { CheckCircleIcon, AnchorIcon, RecycleIcon, TruckIcon, ShieldCheckIcon } from 'lucide-react';
export const WhyChooseSection = () => {
  const reasons = [{
    icon: <AnchorIcon className="w-8 h-8 text-[#234837]" data-id="element-214" />,
    text: 'Gespecialiseerd in jachtinterieurs en bootkussens'
  }, {
    icon: <RecycleIcon className="w-8 h-8 text-[#234837]" data-id="element-215" />,
    text: 'Duurzame, waterbestendige stoffen'
  }, {
    icon: <TruckIcon className="w-8 h-8 text-[#234837]" data-id="element-216" />,
    text: 'Ophalen & bezorgen door heel Nederland'
  }, {
    icon: <ShieldCheckIcon className="w-8 h-8 text-[#234837]" data-id="element-217" />,
    text: '2 jaar garantie op elke stoffering'
  }];
  return <section className="py-20 bg-white" data-id="element-218">
      <div className="container mx-auto px-4" data-id="element-219">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-220">
          35+ jaar vakmanschap op het water
        </h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-221">
          {reasons.map((reason, index) => <div key={index} className="flex items-start space-x-4 p-6 rounded-lg border border-gray-100 shadow-sm" data-id="element-222">
              <div className="flex-shrink-0" data-id="element-223">{reason.icon}</div>
              <div className="flex-1" data-id="element-224">
                <p className="text-lg font-medium" data-id="element-225">{reason.text}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};